export const PROFILE_STUDENT_UPDATE_REQUEST = 'profile/student-update-request'
export const PROFILE_STUDENT_UPDATE_SUCCESS = 'profile/student-update-success'
export const PROFILE_STUDENT_UPDATE_FAILED = 'profile/student-update-failed'
